import { useEffect, useRef, useState } from "react";
import { useGeneralHooks } from "../../../../../Hooks/hooks";
import { IOrdersPageAction, OrdersPageActionTypes } from "../../../../../Interfaces/componentTypes";
import { Clock, OrdersList } from "../../../../../Assets/Icons";
import { IOrdersPageProps } from "./orders";
import CurrentOrders from "./CurrentOrders/currentOrders";
import OrdersHistory from "./OrdersHistory/ordersHistory";
import useDialogHooks from "../../../../../Components/Dialog/dialog-hooks";

const useOrdersPageHook = (props: IOrdersPageProps) => {
    const { company_id, orders, QR, currencySymbol, audioUnlocked } = props;
    const { t, largeScreen } = useGeneralHooks();
    const [activeContent, setActiveContent] = useState<OrdersPageActionTypes>(OrdersPageActionTypes.MY_ORDERS);
    const navRef = useRef<HTMLDivElement>(null);
    const { open: isDialogOpen, onOpen, onClose } = useDialogHooks();
    const navItemRefs = useRef<(HTMLDivElement | null)[]>([]);
    const scrollTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };
    const handleNavClick = (index: number, id: OrdersPageActionTypes) => {
        setActiveContent(id);
        window.scrollTo({ top: 0, behavior: 'smooth' });
        const currentUrl = window.location.href.split('?')[0];
        window.history.pushState({}, '', `${currentUrl}?tab=orders?type=${id}`);

        if (navItemRefs.current[index] && navRef.current && !largeScreen) {
            navItemRefs.current[index]?.scrollIntoView({
                behavior: 'smooth',
                inline: 'center',
                block: 'nearest'
            });
        }
    };

    useEffect(() => {
        !audioUnlocked.current && onOpen()
    }, [audioUnlocked.current]);

    const ordersActions: IOrdersPageAction[] = [
        {
            id: OrdersPageActionTypes.MY_ORDERS,
            title: t('My_Business.My_Orders'),
            icon: OrdersList,
        },
        {
            id: OrdersPageActionTypes.HISTORY,
            title: t('My_Business.Order_History'),
            icon: Clock,
        },
    ];

    useEffect(() => {
        scrollTop()
    }, [activeContent]);

    const PAGE_CONTENTS = {
        [OrdersPageActionTypes.MY_ORDERS]: (
            <CurrentOrders
                company_id={company_id}
                orders={orders}
                QR={QR}
                currencySymbol={currencySymbol}
            />
        ),
        [OrdersPageActionTypes.HISTORY]: (
            <OrdersHistory
                company_id={company_id}
                QR={QR}
                currencySymbol={currencySymbol}
            />
        ),
    };

    return {
        navRef,
        navItemRefs,
        isDialogOpen,
        onClose,
        PAGE_CONTENTS,
        activeContent,
        ordersActions,
        handleNavClick
    }
};

export default useOrdersPageHook